module.exports = __webpack_public_path__ + "static/media/comments.7893ef33.svg";